
import arraydif from '../assets/codewars2/codewars6-6kyu-Array-diff.png'
import findtheunique from '../assets/codewars2/codewars-6-kyu-Find-the-unique-number.jpg'
import multiple3and5 from '../assets/codewars2/multiple3and5.jpg'
import highestscore from '../assets/codewars2/codewars-6kyu-Highest-Scoring-Word.png'

export const codewarsdata2=[
    {
        id:1,
        name:"Array dif",
        image:arraydif,
        github:"https://github.com/AnilBASARAN/codewars6-6kyu-Array-diff",
        live:"https://github.com/AnilBASARAN/codewars6-6kyu-Array-diff/blob/main/codewars6-6kyu-Array-diff.png",
    },
    {
        id:2,
        name:"find the unique",
        image:findtheunique,
        github:"https://github.com/AnilBASARAN/codewars-6-kyu-Find-the-unique-number",
        live:"https://github.com/AnilBASARAN/codewars-6-kyu-Find-the-unique-number/blob/main/codewars-6%20kyu-Find%20the%20unique%20number.jpg",
    },
    {
        id:3,
        name:"multiple 3 and 5",
        image:multiple3and5,
        github:"https://github.com/AnilBASARAN/codewars-6-kyu-Multiples-of-3-or-5",
        live:"https://github.com/AnilBASARAN/codewars-6-kyu-Multiples-of-3-or-5/blob/main/multiple3and5.jpg",
    },
    {
        id:4,
        name:"highest score",
        image:highestscore,
        github:"https://github.com/AnilBASARAN/codewars-6kyu-Highest-Scoring-Word",
        live:"https://github.com/AnilBASARAN/codewars-6kyu-Highest-Scoring-Word/blob/main/codewars-6kyu-Highest-Scoring-Word.png",
    },


]